export const GI_AI_MAX_SELECTED_CAMPAIGNS = 10;
export const GI_AI_MAX_SELECTED_QUESTIONS = 12;

export const getGiAiContextReductionPreview = (rawAnswersCount) => {
  const safeRawAnswersCount = Number(rawAnswersCount) || 0;

  let retentionRate = 1;
  if (safeRawAnswersCount > 10000) {
    retentionRate = 0.3;
  } else if (safeRawAnswersCount > 7500) {
    retentionRate = 0.6;
  } else if (safeRawAnswersCount > 5000) {
    retentionRate = 0.8;
  }

  const keptAnswers = Math.min(
    safeRawAnswersCount,
    Math.ceil(safeRawAnswersCount * retentionRate)
  );

  return {
    rawAnswersCount: safeRawAnswersCount,
    keptAnswers,
    droppedAnswers: Math.max(0, safeRawAnswersCount - keptAnswers),
    retentionRate,
    contextLossRate: safeRawAnswersCount > 0
      ? Math.max(0, 1 - (keptAnswers / safeRawAnswersCount))
      : 0
  };
};
